import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {ContactSourcesEnum, parseContactUid} from '../../../libs/shared/core/src/models/api/contactModel';

/*
 * Constants.
 */

const contactSourceToDisplayNameNodeMap: {[k in ContactSourcesEnum]?: ReactNode} = {
  [ContactSourcesEnum.EMAIL]: <Trans id="contact-source-display-name-email">email</Trans>,
  [ContactSourcesEnum.PHONE]: <Trans id="contact-source-display-name-phone-number">phone number</Trans>,
  [ContactSourcesEnum.TWITTER]: <Trans id="contact-source-display-name-twitter-handle">X handle</Trans>,
  [ContactSourcesEnum.TWITTER_DM]: (
    <Trans id="contact-source-display-name-twitter-dm-handle">X DM handle</Trans>
  ),
  [ContactSourcesEnum.CUSTOM]: <Trans id="contact-source-display-name-custom-handle">custom handle</Trans>,
  [ContactSourcesEnum.FACEBOOK]: <Trans id="contact-source-display-name-facebook-handle">facebook id</Trans>,
};

const defaultHandleNode = <Trans id="contact-source-display-name-handle">handle</Trans>;

/*
 * Types.
 */

interface ContactSourceDisplayNameProps {
  contactUid: string | undefined;
  shouldCapitalize: boolean;
}

/*
 * Style.
 */

interface WrapperSpanProps {
  $shouldCapitalize: boolean;
}

const StyledWrapperSpan = styled.span<WrapperSpanProps>`
  display: inline-block;

  &::first-letter {
    text-transform: ${(p) => (p.$shouldCapitalize ? 'capitalize' : 'none')};
  }
`;

/*
 * Component.
 */

export function getContactSourceDisplayNameNode(contactUid: string | undefined) {
  if (!contactUid) {
    return defaultHandleNode;
  }

  const [source] = parseContactUid(contactUid);
  return contactSourceToDisplayNameNodeMap[source];
}

export const ContactSourceDisplayName: FC<ContactSourceDisplayNameProps> = (props) => {
  const {contactUid, shouldCapitalize} = props;
  const nameNode = getContactSourceDisplayNameNode(contactUid);
  return <StyledWrapperSpan $shouldCapitalize={shouldCapitalize}>{nameNode}</StyledWrapperSpan>;
};
